import React from "react";
import { useMemo } from "react";
import { Typography } from "antd";

import SvgIcon from "./SvgIcon";

const { Text, Title } = Typography;

const LearnTopicsList = ({ onClick, items }) => {
  const itemsList = useMemo(
    () =>
      items.map((item) => (
        <li role="presentation" key={item.title} className="learn-list__item" onClick={() => onClick(item.title)}>
          <SvgIcon className="learn-list__item__icon" iconName={item.icon} />
          <div>
            <Title level={3}>{item.title}</Title>
            <Text className="learn-list__item__subtitle">{item.subTitle}</Text>
          </div>
        </li>
      )),
    [items, onClick]
  );

  return <ul className="learn-list">{itemsList}</ul>;
};

export default LearnTopicsList;
